import { ofType } from "redux-observable";
import { ignoreElements, tap } from "rxjs/operators";
import { IdPersistence } from "../../../../constants/IdPersistence";
import { utilSound } from "../../../../utils/sound/utilSound";
import { utilPersistence } from "../../../../utils/utilPersistence";
import { TypeActionPlayerSettingsInfo, } from "../actionPlayerSettingsInfo";
export var epicSetSound = function (action$) {
    return action$.pipe(ofType(TypeActionPlayerSettingsInfo.SetSound), tap(function (action) {
        var _a;
        utilSound.muteSoundGroup(action.soundGroup, action.enabled);
        utilPersistence.setValue(IdPersistence.Settings, (_a = {},
            _a[action.soundGroup] = action.enabled,
            _a));
    }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/player-settings/epics/epicSetSound.ts
// module id = 1928
// module chunks = 3